<template>
  <div
    v-if="faqItems.length > 1"
    class="flex flex-wrap justify-center gap-3"
  >
    <button
      v-for="(item, index) in faqItems"
      :key="index"
      class="py-2.5 px-4 leading-3 flex-center font-semibold border
        border-green-500 text-green-500 bg-white rounded-full
        hover:bg-green-500 hover:text-white focus:bg-green-500 focus:text-white"
      :data-gtm-action="`scroll to ${item}`"
      @click="scrollToItem(item)"
    >
      {{ item }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { parameterize, scrollToSelector } from '@/utils'
import { onBeforeUnmount, onMounted, ref } from 'vue'

const faqItems = ref<string[]>([])

const scrollToItem = (item: string) => {
  const slug = parameterize(item)
  history.replaceState(null, '', `#${slug}`)
  scrollToSelector(`[data-button-title="${item}"]`, 20)
}

const handleHashScroll = () => {
  const hash = window.location.hash.replace('#', '')
  if (!hash) return

  const normalizedHash = parameterize(decodeURIComponent(hash))

  const target = Array
    .from(document.querySelectorAll<HTMLElement>('[data-button-title]'))
    .find(el => parameterize(el.dataset.buttonTitle || '') === normalizedHash)

  if (target) {
    scrollToSelector(`[data-button-title="${target.dataset.buttonTitle}"]`, 20)
  }
}

onMounted(() => {
  const elements = document.querySelectorAll('[data-button-title]')
  faqItems.value = Array.from(elements).map(element => (element as HTMLElement).dataset.buttonTitle || '')

  handleHashScroll()
  window.addEventListener('hashchange', handleHashScroll)
})

onBeforeUnmount(() => {
  window.removeEventListener('hashchange', handleHashScroll)
})
</script>
